import * as React from "react"

import { cn } from "@/v2/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  function Input({ className, type, ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          // pl-3/pr-3 (not px-3): v1's global Bootstrap CDN stylesheet defines
          // its own `.px-3 { padding-inline: 1rem !important }` utility, which
          // silently overrides this class's padding (and any pl-9/pr-9 icon
          // offset a caller adds) since `!important` beats Tailwind's utility
          // regardless of layers or specificity - e.g. a leading-icon input's
          // icon overlapped its placeholder text. Bootstrap 5's spacing
          // utilities are logical (ps-3/pe-3), not physical, so pl-3/pr-3 have
          // no Bootstrap equivalent to collide with.
          "h-9 w-full min-w-0 rounded-md border border-input bg-transparent pl-3 pr-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
          "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
          "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          className
        )}
        {...props}
      />
    )
  }
)

export { Input }
